//
//
//
//
//
//
//
//
//

import inschrijvenStudent from '~/graphql/mutations/inschrijvenStudent.gql';

export default {
  auth: false,
  data: () => ({
    formData: {},
    step: 0,
    error: null,
    idealLink: null,
    done: false,
  }),
  methods: {
    next() {
      if (++this.step > 2) {
        this.sendData();
      }
    },
    setFormData(data) {
      this.formData = data;
    },
    checkRequiredFile(key) {
      return this.getKey(`${key}.files.0.file`, true);
    },
    getKey(key, required = false) {
      /** @var {string[]} */
      const parts = key.split('.');
      let value = this.formData;
      while (parts.length > 0) {
        const part = parts.shift();
        if (typeof value[part] === 'undefined') {
          if (required) {
            throw new Error(`required ${key} is missing`);
          } else {
            return null;
          }
        }
        value = value[part];
      }
      return value;
    },
    parseFormData() {
      return {
        voornaam: this.formData.voornaam,
        tussenvoegsel: this.formData.tussenvoegsel,
        achternaam: this.formData.achternaam,
        e_mailadres: this.formData.e_mailadres,
        telefoonnummer: this.formData.telefoonnummer,
        opleiding: this.formData.opleiding,
        opleiding_organisatie: this.formData.opleiding_organisatie,
        email_opleiding: this.formData.email_opleiding,
        bewijs: this.checkRequiredFile('bewijs'),
        adres: this.formData.adres,
        huisnummer: parseInt(this.formData.huisnummer),
        plaats: this.formData.plaats,
        postcode: this.formData.postcode,
        toevoeging: this.formData.toevoeging,
        land: this.formData.land,
        scag: this.formData.scag,
      };
    },
    async sendData() {
      this.step = 3;
      try {
        await this.$apollo.mutate({
          mutation: inschrijvenStudent,
          variables: this.parseFormData(),
        }).then(({data}) => {
          this.done = true;
          this.idealLink = data.inschrijvenStudent;
        });
      } catch (err) {
        this.error = err;
        this.step = 2;
        this.$toast.error('Er is iets fout gegaan.');
        console.log(err);
      }
    },
  },
};
